var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('data-import',{attrs:{"visible":_vm.mix_showImportModal,"templateUrl":_vm.mix_templateUrl,"actionUrl":_vm.mix_actionUrl},on:{"update:visible":function($event){_vm.mix_showImportModal=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }